import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { GalleryManagement, GetGalleryParams } from './galleryManagement.types';

export const getGallery = (client: AxiosInstance) => async (params?: GetGalleryParams) => {
  return (await client.get<PaginatedApiResponse<GalleryManagement[]>>(API_ROUTES.GET_GALLERY, { params })).data;
};

export const galleryListQueries = {
  all: () => ['galleryList'],
  list: (params?: GetGalleryParams) =>
    queryFactoryOptions<PaginatedApiResponse<GalleryManagement[]>>({
      queryKey: [...galleryListQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getGallery(client)(params),
    }),
};
